export class DirectDebit {
  constructor({
    directDebitID = 0,
    accountName = '',
    bsb = '',
    accountNumber = '',
    financialInstitutionName = '',
    financialInstitutionBranch = '',
    useExisting = false,
    payWithCreditCard = false,
    noDetailsProvided = true,
  } = {}) {
    this.directDebitID = directDebitID;
    this.accountName = accountName;
    this.bsb = bsb;
    this.accountNumber = accountNumber;
    this.financialInstitutionBranch = financialInstitutionBranch;
    this.financialInstitutionName = financialInstitutionName;
    this.useExisting = useExisting;
    this.payWithCreditCard = payWithCreditCard;
    this.noDetailsProvided = noDetailsProvided;
  }
}

export function CreateDirectDebit(data) {
  return Object.freeze(new DirectDebit(data));
}
